import { render, staticRenderFns } from "./scheme-advantages-DigitalFactorySolutions.vue?vue&type=template&id=5d26da54&scoped=true"
import script from "./scheme-advantages-DigitalFactorySolutions.vue?vue&type=script&lang=js"
export * from "./scheme-advantages-DigitalFactorySolutions.vue?vue&type=script&lang=js"
import style0 from "./scheme-advantages-DigitalFactorySolutions.vue?vue&type=style&index=0&id=5d26da54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d26da54",
  null
  
)

export default component.exports